module.exports = __webpack_public_path__ + "67c75943d33b78c6efff302f13bac896.pdf";